import React from 'react';
import { CalendarClock } from 'lucide-react';

// Times are IST; a Needed At without an offset (datetime-local) is IST wall time.
export const fmtIST = (v) => {
  const s = String(v || '');
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(s) ? s : `${s}+05:30`);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata' });
};
const fmt = fmtIST;

/** "Needed 08 Oct, 10:00 AM" + "Scheduled · auto-assigns 09:00 AM" for future requests. */
export const ScheduleInfo = ({ r, testId }) => {
  if (!r?.needed_at) return null;
  return (
    <div className="text-[11px] mt-1 space-y-0.5" data-testid={testId}>
      <p className="text-gray-600 flex items-center gap-1"><CalendarClock className="w-3 h-3" />Needed {fmt(r.needed_at)}</p>
      {r.scheduled && r.assign_after && (
        <p className="text-indigo-700 font-medium" data-testid={`${testId}-scheduled`}>Scheduled · auto-assigns {fmt(r.assign_after)}</p>
      )}
    </div>
  );
};

export default ScheduleInfo;
